// oxlint-disable require-await
import {dialog} from '@cypro/ui/components'
import {DeleteResourceDialog} from '@cypro/ui/components'
import {useZero} from '@/shared/integrations/zero/use-zero'
import {DeleteResourceSchema} from '@cypro/engine/mutators/util'
import {useTranslate} from '@tolgee/react'
import {useCallback} from 'react'

export function useDeleteDrugsCategory() {
  const zero = useZero()

  return useCallback(
    async (payload: DeleteResourceSchema) =>
      zero.attemptMutation(zero.mutators.drugsCategories.delete(payload), async ({server}) => {
        const result = await server
        return result
      }),
    [zero]
  )
}

export function useConfirmDeleteDrugsCategory() {
  const {t: tCategories} = useTranslate('categories')
  const deleteCategory = useDeleteDrugsCategory()

  return useCallback(
    async (payload: DeleteResourceSchema) => {
      const confirmed = await dialog.open(payload.id, {
        children: (
          <DeleteResourceDialog
            id={payload.id}
            title={tCategories('delete_category_dialog.title')}
            description={tCategories('delete_category_dialog.description')}
          />
        ),
      })
      if (!confirmed) throw new Error('User did not confirm')

      const deleteRes = await deleteCategory(payload)
      if (!deleteRes) throw new Error('Unexpected error')
      if (deleteRes.type === 'error') throw deleteRes.error
    },
    [tCategories, deleteCategory]
  )
}
